// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.news-detail-section {
  width: 60%;
}

.news-detail-section .img-news-container {
  width: 100%;
}

.img-news-container img {
  width: 50%;
}

.news-content-text {
  font-size: 1.1rem;
  text-align: justify;
}

.another-news-section {
  width: 60%;
  position: relative;
}

.another-news-section .swiper-4 {
  width: 100%;
  height: 100%;
}

.another-news-section .another-news-section-cardContainer .card {
  display: flex;
  justify-content: center;
  align-items: start;
  width: 100%;
  height: 400px;
  cursor: pointer;
  border: none;
}

.another-news-section .another-news-section-cardContainer .card:hover {
  transition: 0.2s ease-in;
  color: #327a6d;
  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;
}

.another-news-section .another-news-section-cardContainer .card img {
  object-fit: cover;
  width: 100%;
  height: 150px;
}

.another-news-section.swiper-pagination-4 {
  display: none;
}

.another-news-section .swiper-button-prev-4,
.another-news-section .swiper-button-next-4 {
  color: #327a6d;
}

@media (max-width: 1650px) {
  .news-detail-section {
    width: 75%;
  }
  .another-news-section {
    width: 75%;
  }
  .img-news-container img {
    width: 40%;
  }
  .another-news-section .another-news-section-cardContainer .card img {
    height: 190px;
  }
}

@media (min-width: 600px) and (max-width: 1080px) {
  .img-news-container img {
    width: 100%;
  }
  .another-news-section .another-news-section-cardContainer .card img {
    height: 205px;
  }
}

@media (max-width: 580px) {
  .img-news-container img {
    width: 100%;
  }

  .another-news-section .another-news-section-cardContainer .card img {
    height: 205px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/newsdetail.css"],"names":[],"mappings":"AAAA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,wBAAwB;EACxB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".news-detail-section {\r\n  width: 60%;\r\n}\r\n\r\n.news-detail-section .img-news-container {\r\n  width: 100%;\r\n}\r\n\r\n.img-news-container img {\r\n  width: 50%;\r\n}\r\n\r\n.news-content-text {\r\n  font-size: 1.1rem;\r\n  text-align: justify;\r\n}\r\n\r\n.another-news-section {\r\n  width: 60%;\r\n  position: relative;\r\n}\r\n\r\n.another-news-section .swiper-4 {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.another-news-section .another-news-section-cardContainer .card {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: start;\r\n  width: 100%;\r\n  height: 400px;\r\n  cursor: pointer;\r\n  border: none;\r\n}\r\n\r\n.another-news-section .another-news-section-cardContainer .card:hover {\r\n  transition: 0.2s ease-in;\r\n  color: #327a6d;\r\n  box-shadow: rgba(0, 0, 0, 0.15) 1.95px 1.95px 2.6px;\r\n}\r\n\r\n.another-news-section .another-news-section-cardContainer .card img {\r\n  object-fit: cover;\r\n  width: 100%;\r\n  height: 150px;\r\n}\r\n\r\n.another-news-section.swiper-pagination-4 {\r\n  display: none;\r\n}\r\n\r\n.another-news-section .swiper-button-prev-4,\r\n.another-news-section .swiper-button-next-4 {\r\n  color: #327a6d;\r\n}\r\n\r\n@media (max-width: 1650px) {\r\n  .news-detail-section {\r\n    width: 75%;\r\n  }\r\n  .another-news-section {\r\n    width: 75%;\r\n  }\r\n  .img-news-container img {\r\n    width: 40%;\r\n  }\r\n  .another-news-section .another-news-section-cardContainer .card img {\r\n    height: 190px;\r\n  }\r\n}\r\n\r\n@media (min-width: 600px) and (max-width: 1080px) {\r\n  .img-news-container img {\r\n    width: 100%;\r\n  }\r\n  .another-news-section .another-news-section-cardContainer .card img {\r\n    height: 205px;\r\n  }\r\n}\r\n\r\n@media (max-width: 580px) {\r\n  .img-news-container img {\r\n    width: 100%;\r\n  }\r\n\r\n  .another-news-section .another-news-section-cardContainer .card img {\r\n    height: 205px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
